export interface InternationalTopUpOperator {
    readonly id: string;
    readonly name: string;
    readonly isDefault: boolean;
}
